import React, { useEffect } from 'react';

import { observer } from 'mobx-react';
import { TitleWithDescription, InfoBox, Switch } from '@infoods/lifebase-ui';

import classes from './NgzManageInbodyPinCodeWidget.module.scss';
import { ManagePin } from './ManagePin/ManagePin';
import { entityInbodyPinCodeStore } from '../../stores/entityInbodyPinCodeStore';
import { angularizeWithProviders } from '../../../shared/providers/angularizeWithProviders/angularizeWithProviders';

type NgzManageInbodyPinCodeWidgetProps = {
  entityId: number;
};

const NgzManageInbodyPinCodeWidget = observer(
  ({ entityId }: NgzManageInbodyPinCodeWidgetProps) => {
    const { pinCodeData, togglePin, getPin, setDefaultValues } = entityInbodyPinCodeStore;

    const { enabled } = pinCodeData || {};

    useEffect(() => {
      getPin(entityId);

      return setDefaultValues;
    }, [entityId]);

    return (
      <InfoBox title="User Registration Form" contentClassName={classes.container}>
        <Switch checked={enabled} onChange={(_, checked) => togglePin(checked)} />
        <TitleWithDescription
          title="InBody PIN Setup"
          description={
            <>
              The assigned PIN will appear to the customer after they complete payment in
              the client form.
              <br />
              By entering this PIN on the InBody machine, the customer will be able to
              start their body scan.
            </>
          }
          titleFont="body-14-bold"
        />
        <ManagePin />
      </InfoBox>
    );
  },
);

angularizeWithProviders(NgzManageInbodyPinCodeWidget, 'ngzManageInbodyPinCodeWidget', {
  entityId: '<',
});

export { NgzManageInbodyPinCodeWidget };
